"use client";
/* eslint-disable @typescript-eslint/no-explicit-any */
import * as React from 'react';
import { useAuth } from '@/context/auth-context';
import { usePathname, useRouter } from 'next/navigation';

interface OAuthAuthListenerProps {
  redirectMap?: Partial<Record<string,string>>; // role -> path
  fallback?: string;
}

// Listens for CustomEvent('ace:oauth-auth', { detail }) and updates auth context.
export function OAuthAuthListener({ redirectMap, fallback = '/' }: OAuthAuthListenerProps) {
  const { setAuth } = useAuth();
  const router = useRouter();
  const pathname = usePathname();

  React.useEffect(() => {
    function handler(e: Event) {
      const detail = (e as CustomEvent).detail as any;
      if (!detail || !detail.access_token || !detail.user) return;
      const u = detail.user;
      // Infer role if not present
  const inferredRole = (u.role as string) || (pathname.includes('/preceptor') ? 'preceptor' : 'student');
  // Constrain to known roles
  const role = (['preceptor','student','admin','staff'].includes(inferredRole) ? inferredRole : undefined) as 'preceptor' | 'student' | 'admin' | 'staff' | undefined;
      const name = [u.firstName, u.lastName].filter(Boolean).join(' ') || u.email;
  setAuth({ id: u.id, email: u.email, role, name }, detail.access_token);
      const target = (role && redirectMap?.[role]) || (role === 'preceptor' ? '/preceptor' : '/student/profile');
      router.push(target || fallback);
    }
    window.addEventListener('ace:oauth-auth', handler as any);
    return () => window.removeEventListener('ace:oauth-auth', handler as any);
  }, [fallback, redirectMap, router, setAuth, pathname]);

  return null; // no UI
}

export default OAuthAuthListener;
